import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Text, useTheme } from "native-base";
import { isWeb } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import DropdownForComponents from "../../molecules/DropdownForComponents";
import Icon from "../../icons/Icon";
import useResponsive from "../../util/useResponsive";
import ProfileItem from "./ProfileItem";
const PatientSelect = ({ selectedPatient, me, patients, onChange }) => {
    var _a, _b;
    const [isOpen, setIsOpen] = useState(false);
    const { colors } = useTheme();
    const { t } = useTranslation();
    const { isMediumScreen } = useResponsive();
    const isSelfSelected = (selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient.userId) === (me === null || me === void 0 ? void 0 : me.userId);
    const $colors = isSelfSelected
        ? {
            color: colors.gray[600],
            border: colors.gray[100],
            bg: colors.white,
            cardBorder: colors.gray[100],
        }
        : {
            color: colors.blue[700],
            border: colors.blue[500],
            bg: "#E2EEFF",
            cardBorder: colors.blue[300],
        };
    const styles = {
        slot: {
            backgroundColor: $colors.bg,
            borderColor: $colors.border,
            color: $colors.color,
            borderWidth: 1,
            borderRadius: 8,
            columnGap: 12,
            paddingBlock: 8,
            paddingInline: 24,
            width: "100%",
            height: isMediumScreen ? (isWeb ? 80 : 70) : "auto",
            overflow: isOpen ? undefined : "hidden",
        },
        svg: {
            flexShrink: 0,
        },
        text: {
            box: {
                flex: 1,
                minHeight: isMediumScreen ? 50 : "auto",
            },
            base: {
                color: "inherit",
            },
            trusteeName: {
                color: colors.blue[500],
            },
            userName: {
                color: "inherit",
            },
        },
        dropdown: {
            absolute: {
                top: isMediumScreen ? 0 : -25,
                height: isMediumScreen ? 50 : "auto",
                width: isMediumScreen ? "100%" : "auto",
                padding: isMediumScreen ? 8 : 0,
                zIndex: 100,
            },
            border: {
                backgroundColor: $colors.bg,
                borderColor: $colors.cardBorder,
                borderWidth: 1,
                borderRadius: 4,
                height: 50,
                width: "100%",
            },
            selections: {
                backgroundColor: $colors.bg,
                borderColor: $colors.cardBorder,
                borderBottomWidth: 1,
                top: 0,
                height: 150,
            },
        },
    };
    return (_jsxs(Box, Object.assign({ style: styles.slot, flexDirection: {
            base: "column",
            xl: "row",
        }, alignItems: {
            base: "flex-start",
            xl: "center",
        }, justifyContent: {
            base: "flex-start",
            xl: "space-between",
        }, mb: 3, zIndex: 1, minHeight: "70px" }, { children: [!isMediumScreen && (_jsxs(Box, Object.assign({ display: "flex", flexDirection: "row", height: {
                    base: 50,
                    md: "auto",
                }, 
                //alignItems="flex-start"
                px: {
                    base: 2,
                    md: 0,
                }, pt: 2 }, { children: [isSelfSelected ? (_jsx(Box, { children: _jsx(Icon, { name: "user", size: 24, fill: colors.green[400] }) })) : (_jsx(Box, Object.assign({ h: "25", alignItems: "center", flexDirection: "row" }, { children: _jsx(Icon, { name: "userAdmin", size: 24, fill: colors.blue[500] }) }))), _jsx(Box, Object.assign({ style: styles.text.box, flexDirection: "row", alignItems: "center", flexWrap: "wrap", ml: {
                            base: 2,
                            md: 2,
                        } }, { children: _jsx(Text, Object.assign({ style: styles.text.base }, { children: isSelfSelected ? (_jsx(Text, Object.assign({ style: styles.text.userName }, { children: `Üdvözöljük, ${me === null || me === void 0 ? void 0 : me.fullName}!` }))) : (_jsxs(_Fragment, { children: ["Jelenleg", _jsx(Text, Object.assign({ style: styles.text.trusteeName, fontWeight: "500" }, { children: ` ${selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient.fullName} ` })), "adatlapj\u00E1nak megtekint\u00E9se, mint:", _jsx(Text, Object.assign({ style: styles.text.userName, fontWeight: "500" }, { children: ` ${(_a = me === null || me === void 0 ? void 0 : me.fullName) !== null && _a !== void 0 ? _a : ""} ` })), isSelfSelected
                                        ? `(${t("ownAccount")})`
                                        : `(${t("authorizedPersonsAccount")})`] })) })) }))] }))), _jsx(DropdownForComponents, { isOpen: isOpen, propStyles: {
                    absolute: styles.dropdown.absolute,
                    dropdown: styles.dropdown.selections,
                }, triggerChild: _jsx(ProfileItem, { profile: selectedPatient, isTrigger: true, userId: (_b = me === null || me === void 0 ? void 0 : me.userId) !== null && _b !== void 0 ? _b : "", onPress: () => setIsOpen((state) => !state), propStyles: styles.dropdown.border }), dropdownChildren: patients.map(($profile) => {
                    var _a;
                    return (_jsx(ProfileItem, { profile: $profile, userId: (_a = me === null || me === void 0 ? void 0 : me.userId) !== null && _a !== void 0 ? _a : "", onPress: () => {
                            onChange === null || onChange === void 0 ? void 0 : onChange($profile === null || $profile === void 0 ? void 0 : $profile.userId);
                            setIsOpen((state) => !state);
                        } }, $profile === null || $profile === void 0 ? void 0 : $profile.userId));
                }) })] })));
};
export default PatientSelect;
